import React from 'react';
import { Box } from '@mui/material';
import PageHeader from '@organisms/PageHeader';

export interface PageContentProperties {
  header?: string | React.ReactNode;
  breadcrumb?: React.ReactNode;
  children: React.ReactNode;
}

function PageContent({ header, breadcrumb, children }: Readonly<PageContentProperties>) {
  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '1600px',
        mx: 'auto',
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 2, sm: 3 },
        pb: 6, // Add padding bottom for footer
      }}
    >
      {breadcrumb && <Box sx={{ mb: 1 }}>{breadcrumb}</Box>}
      {header && typeof header === 'string' && <PageHeader>{header}</PageHeader>}
      {header && typeof header !== 'string' && header}
      <Box
        sx={{
          mt: header ? 3 : 0,
          width: '100%',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

export default PageContent;